import { createAction } from '../../libs/saga-utils';

const ns = 'system';

export const SYSTEM_TYPES = {
  APP_STARTING: `${ns}/APP_STARTING`,
  APP_STARTED: `${ns}/APP_STARTED`
};

export const SYSTEM_ACTIONS = {
  appStarting: createAction(SYSTEM_TYPES.APP_STARTING),
  appStarted: createAction(SYSTEM_TYPES.APP_STARTED)
};
